import { useState } from 'react';

type PythonProps = {
  paddValue?: number;
};

export const Python1 = ({ paddValue }: PythonProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div style={{ paddingLeft: `${paddValue}px` }}>
      <code>{'export default function About() {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'return <h1>About Us</h1>;'}
      </code>
      <br />
      <code>{'}'}</code>
    </div>
  );
};
